export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-arrow-up-62fb1f9ce96e1973a9aeef19d24dec63.svg";